import { FunctionComponent, useEffect, useState } from "react";
import KlinikaTyIDziecko from "../../assets/pictures/Logos/ktid.png";
import Ostoja from "../../assets/pictures/Logos/ostoja.png";
import CMKawiary from "../../assets/pictures/Logos/cmkawiary.webp";
import { Flex, Modal } from "antd";
import Phone from "../../assets/pictures/Icons/phone";
import { FiAlertCircle } from "react-icons/fi";

interface PrivateVisitsProps {}

const PrivateVisits: FunctionComponent<PrivateVisitsProps> = () => {
  const [openCMK, setOpenCMK] = useState<boolean>(false);
  const [openOstoja, setOpenOstoja] = useState<boolean>(false);

  useEffect(() => {
    if (openCMK) {
      const mydrScript = document.getElementsByTagName("script")[0];
      const js = document.createElement("script");
      js.src = "https://mydr.pl/static/mydr-pp.min.js";
      mydrScript?.parentNode?.insertBefore(js, mydrScript);

      js.onload = () => {
        const PatientsPlugin = new (window as any).PatientsPlugin();
        PatientsPlugin.init({
          app: "https://mydr.pl/patients_plugin",
          plugin: "https://mydr.pl/static",
        });
      };
    }
  }, [openCMK]);

  return (
    <div className="private-visits-wrapper" id="private">
      <div className="private-visits-section">
        <div className="title">
          <h2>Wizyty prywatne</h2>
        </div>

        <div className="private-visits-cards">
          <div className="card">
            <div className="card-image">
              <img src={Ostoja} alt="placeholder" />
              <div className="card-text">
                <h3>OSTOJA Centrum Medyczne</h3>
                <p>ul. Energetyka 2a</p>
                <p>63-800 Gostyń</p>
              </div>
              <div className="card-action">
                <button
                  onClick={() => {
                    setOpenOstoja(true);
                  }}
                >
                  dowiedz się więcej
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        title="OSTOJA Centrum Medyczne"
        open={openOstoja}
        onCancel={() => setOpenOstoja(false)}
        footer={null}
        centered
      >
        <Flex vertical gap="middle">
          <div className="alert-info">
            <FiAlertCircle className="alert-icon" />
            <p>
              Zapisując DZIECKO wpisz jego imię i nazwisko, swój telefon
              kontaktowy, swój adres mailowy!
            </p>
          </div>
          <div className="alert">
            <FiAlertCircle className="alert-icon" />
            <p>
              W razie problemów z przyjazdem na uzgodnioną wizytę bardzo proszę
              o powiadomienie rejestracji celem anulowania rezerwacji terminu
              wizyty. Wizyty umawiane przez terminarze dostępne w internecie
              można anulować samodzielnie - rejestracja zostanie automatycznie
              powiadomiona.
            </p>
          </div>
          <div
            className="points-wrapper"
            style={{
              textAlign: "center",
            }}
          >
            <h4>Przyjęcia po uprzedniej rejestracji telefonicznej</h4>
            <div
              className="point"
              style={{
                justifyContent: "center",
              }}
            >
              <Phone className="fill" />
              <p
                style={{
                  width: "max-content",
                }}
              >
                510 921 916
              </p>
            </div>
            <h4>Lub</h4>
            <Flex vertical gap="small" justify="center" align="center">
              <button
                className="button-primary"
                onClick={() => {
                  window.open(
                    "https://lekarzebezkolejki.pl/mariusz-sroczynski-2/gostyn",
                    "_blank",
                  );
                }}
              >
                Umów wizytę samodzielnie
              </button>
              <button
                className="button-secondary"
                onClick={() => {
                  window.open("http://www.ostoja-gostyn.pl/", "_blank");
                }}
              >
                Strona www
              </button>
            </Flex>
          </div>
        </Flex>
      </Modal>
      <Modal
        title="Centrum Medyczne Kawiary"
        open={openCMK}
        onCancel={() => setOpenCMK(false)}
        footer={null}
        centered
      >
        <Flex vertical gap="middle">
          <div className="alert-info">
            <FiAlertCircle className="alert-icon" />
            <p>
              Zapisując DZIECKO wpisz jego imię i nazwisko, swój telefon
              kontaktowy, swój adres mailowy!
            </p>
          </div>
          <div className="alert">
            <FiAlertCircle className="alert-icon" />
            <p>
              W razie problemów z przyjazdem na uzgodnioną wizytę bardzo proszę
              o powiadomienie rejestracji celem anulowania rezerwacji terminu
              wizyty. Wizyty umawiane przez terminarze dostępne w internecie
              można anulować samodzielnie - rejestracja zostanie automatycznie
              powiadomiona.
            </p>
          </div>
          <div
            className="points-wrapper"
            style={{
              textAlign: "center",
            }}
          >
            <h4>Przyjęcia po uprzedniej rejestracji telefonicznej</h4>
            <div
              className="point"
              style={{
                justifyContent: "center",
              }}
            >
              <Phone className="fill" />
              <p
                style={{
                  width: "max-content",
                }}
              >
                616 469 900
              </p>
            </div>
            <h4>Lub</h4>
            <Flex vertical gap="small" justify="center" align="center">
              <button
                className="btn-mydr-pp"
                data-doctor=""
                data-speciality="chirurg dziecięcy"
                data-visitkind=""
                data-evisit="false"
                data-appname="drw"
                data-token="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJmYWNpbGl0eV9pZCI6MTg0NzF9.pfquNc93FCHRwM3kUPjpA_SNl2BTybKcl8LzFvUz76s"
              ></button>
              <button
                className="button-secondary"
                onClick={() => {
                  window.open("https://www.cmkawiary.pl/", "_blank");
                }}
              >
                Strona www
              </button>
            </Flex>
          </div>
        </Flex>
      </Modal>
    </div>
  );
};

export default PrivateVisits;
